import type { QChartTemplateRule } from "@coreapp/CoreApp/QChartTemplateRule";
import { Flex, Text } from "@theorgchartdev/storybook";
import * as StateLib from "@/Utils/StateLib";

interface RuleRowProps {
  rule: QChartTemplateRule;
  index?: number;
}

export const RuleRow = ({ rule, index }: RuleRowProps) => {
  return (
    <div className={"view-panel-items-rulerow"}>
      <Flex gap={"8px"}>
        {index != null && (
          <Text size={"small"} modifier="bold">
            {index + "."}
          </Text>
        )}
        <Flex direction={"column"} gap={"4px"} justifyContent={"flex-start"}>
          <CriteriaContent rule={rule} />
          <ActionContent rule={rule} />
        </Flex>
      </Flex>
    </div>
  );
};

const CriteriaContent = ({ rule }: { rule: QChartTemplateRule }) => {
  const doc = StateLib.GetDoc();
  if (!doc) {
    return null;
  }
  return (
    <Text modifier={"medium"} size={"small"}>
      {rule.GetRuleString(doc)}
    </Text>
  );
};

const ActionContent = ({ rule }: { rule: QChartTemplateRule }) => {
  const wsMgr = StateLib.GetWSMgr();
  const doc = StateLib.GetDoc();
  const boxStylesMgr = wsMgr?.GetBoxStylesMgr();
  const ctm = wsMgr?.GetChartTemplatesMgr();

  if (!boxStylesMgr || !ctm || !doc) {
    return null;
  }

  return (
    <Flex direction="column">
      {rule.GenerateActionStr(boxStylesMgr, ctm, doc).map((item, idx) => (
        <Text key={idx} size={"small"}>
          {item}
        </Text>
      ))}
    </Flex>
  );
};
